import { APPLICANT_STAGES, type ApplicantStage } from './applicant-stage';

export const REFERRAL_REPORTS_NOTE =
  'These figures are for tracking, not ranking. They don’t rank trustees, families or children and play no part in admission decisions.';

export const APPLIED_STAGES: readonly ApplicantStage[] = APPLICANT_STAGES.slice(
  APPLICANT_STAGES.indexOf('application_complete'),
);

export const NO_SCHOOL_LABEL = 'Not provided';

export function percentOf(count: number, total: number): number | null {
  return total > 0 ? Math.round((count / total) * 100) : null;
}

export function orderGrades(configured: readonly string[], present: Iterable<string>): string[] {
  const seen = new Set(present);
  const known = configured.filter((g) => seen.has(g));
  const others = [...seen]
    .filter((g) => !configured.includes(g))
    .sort((a, b) => a.localeCompare(b, undefined, { numeric: true }));
  return [...known, ...others];
}

const monthFormat = new Intl.DateTimeFormat('en-US', {
  month: 'long',
  year: 'numeric',
  timeZone: 'UTC',
});

export function monthLabel(month: string): string {
  const [y, m] = month.split('-').map(Number);
  return y && m ? monthFormat.format(Date.UTC(y, m - 1, 1)) : month;
}

export function monthRange(month: string): { from: string; to: string } {
  const [y, m] = month.split('-').map(Number);
  const last = new Date(Date.UTC(y!, m!, 0)).getUTCDate();
  return { from: `${month}-01`, to: `${month}-${String(last).padStart(2, '0')}` };
}
